// extracted by mini-css-extract-plugin
export default {"img":"box_img__0ZYBw","button":"box_button__Xm5K-","container":"box_container__uF+aW","flexItem":"box_flexItem__QMt7E","flex60":"box_flex60__p6dkZ","flex40":"box_flex40__beB2i"};